import { Absence } from '@src/pages';
import {
  prefetchAbsences,
  prefetchAbsenceTypes,
  prefetchResourceUsers,
} from '@src/query';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/absence')({
  loader: ({ context }) => {
    const { apiClient } = context;
    prefetchResourceUsers(apiClient);
    prefetchAbsences(apiClient);
    prefetchAbsenceTypes(apiClient);
  },
  component: Absence,
});
